import { combineReducers } from 'redux'

import list from './list/slice'

const sentReducer = combineReducers({
  list,
})

export default sentReducer
